const STORAGE_KEY = "dueTodayCongratulationsDisabled";

export const isDueTodayCongratulationsDisabled = () =>
  localStorage.getItem(STORAGE_KEY) === "true";

export const setDueTodayCongratulationsDisabled = (disabled) =>
  localStorage.setItem(STORAGE_KEY, String(disabled));
